import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

export const MainRoutes: Routes = [
  { path: 'auth', loadChildren: './auth/auth.module#AuthModule' },
  { path: 'error', loadChildren: './error/error.module#ErrorModule' },
  { path: '', redirectTo: '/app/index', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(MainRoutes)],
  exports: [RouterModule]
})
export class MainRoutingModule { }



// WEBPACK FOOTER //
// E:/GangaJewallery-Final/app.server/systemic.app.server/client/src/main/main.routing.ts